import { useMemo, useState } from "react";
import Switch from "react-switch";
import {
  ToggleEnableActionWrapper,
  convertBool
} from "./OtherConfigurationItems/ToggleEnableActionWrapper";
import { DropdownSelectWrapper } from "./OtherConfigurationItems/DropdownSelectWrapper";
import { TranslationService } from "../../../services/TranslationService";
import FilterService, {
  FilterCollection
} from "../../../services/FilterService";
import CompanyService from "../../../services/CompanyService";

type GroupInvoicesinEmailsandLettersType = {
  alloweditgroupmailby: "False" | "True";
  groupmailby: any;
  groupbyorderdesc: "False" | "True";
};

export const GroupInvoicesinEmailsandLetters = ({
  alloweditgroupmailby,
  groupmailby,
  groupbyorderdesc
}: GroupInvoicesinEmailsandLettersType) => {
  const initialShow =
    convertBool[alloweditgroupmailby] ||
    (Array.isArray(groupmailby) ? groupmailby.length > 1 : !!groupmailby);
  const [showValues, setShowValues] = useState<boolean>(initialShow);

  const listItemsFields = useMemo(() => {
    return FilterService.GetFiltersForPage(
      FilterCollection.GroupInvoicesEmailsAndLetters
    ).flatMap(({ definitions }) =>
      definitions.map((x) => ({
        value: x.Field.replace("additional-", ""),
        text: x.Name ?? ""
      }))
    );
  }, []);

  const handleToggle = async (next: boolean) => {
    setShowValues(next);
    if (!next) {
      try {
        await CompanyService.setConfigCompany({
          groupmailby: null,
          alloweditgroupmailby: false,
          groupbyorderdesc: false
        });
      } catch (e) {
        console.error("Error reseteando configuración:", e);
      }
    }
  };

  return (
    <div className="configuration-display-item">
      <div className="mb-3">
        <div className="d-flex col-md-8 justify-content-between align-items-center">
          <td className="col-auto py-0">
            <div className="configuration-display-item">
              {TranslationService.getTranslation(
                "GroupInvoicesinEmailsandLetters"
              )}
            </div>
          </td>
          <td className="py-0">
            <Switch
              onColor={"#080"}
              checked={showValues}
              onChange={handleToggle}
              height={24}
              width={50}
              uncheckedIcon={false}
            />
          </td>
        </div>
      </div>

      {showValues && (
        <div className="col-auto" style={{ marginRight: 50 }}>
          <div className="mb-2">
            <ToggleEnableActionWrapper
              title="AllowManualGroupingEdit"
              action="alloweditgroupmailby"
              initialValue={alloweditgroupmailby}
              notRefresh
            />
          </div>

          <div className="mb-2">
            <DropdownSelectWrapper
              initialValue={groupmailby}
              items={[
                { value: "", text: TranslationService.translate.NoneValue },
                ...listItemsFields
              ]}
              title="DefaultGrouping"
              action="groupmailby"
            />
          </div>

          <div className="mb-2">
            <ToggleEnableActionWrapper
              title="DescendingOrderZA"
              action="groupbyorderdesc"
              initialValue={groupbyorderdesc}
              notRefresh
            />
          </div>
        </div>
      )}
    </div>
  );
};
